import { render, staticRenderFns } from "./contentBox.vue?vue&type=template&id=a096884c&scoped=true"
import script from "./contentBox.vue?vue&type=script&lang=js"
export * from "./contentBox.vue?vue&type=script&lang=js"
import style0 from "./contentBox.vue?vue&type=style&index=0&id=a096884c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_l6qkhjtl3zrn5vuc55gru6hoa4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a096884c",
  null
  
)

export default component.exports